$(function(){
	

	$('.form__wrapp').append(`<div class="checkbox__default">
			<input type="checkbox" name="politics" id="politics" checked>
			<label for="politics"><p>Вы соглашаетесь с <a data-policy="policy">политикой конфиденциальности</a></p></label>
		</div>`);

    $('.price__form').append(`<div class="checkbox__default">
			<input type="checkbox" name="politics" id="politics" checked>
			<label for="politics"><p>Вы соглашаетесь с <a data-policy="policy">политикой конфиденциальности</a></p></label>
		</div>`);

    
})

import './_components';

$('.btn__upper').on('click', function() {
  $('.portfolio__content').stop().animate({
    scrollTop: 0
  }, 300);
});

$(function(){

  $(window).on('scroll', function() {
    if (($(this).scrollTop() > 100)){
      if ($('.btn__upper').is(':hidden')) {
        $('.btn__upper').css({opacity : 1}).fadeIn('slow');
      }
    } else { 
      $('.btn__upper').stop(true, false).fadeOut('fast'); 
    }
  });

  $('.chaty-svg').addClass('customize')

  if(window.innerWidth <= 990){
    document.querySelector('.chaty-channel .on-hover-text').textContent = 'Есть вопросы?';
    /* $('.on-hover-text').hide(); */
  }

  let policy = false;

  $('a[data-policy="policy"]').click(function(){
    if(policy == false){
      $('.modal-policy').addClass('mp-open');
      $('.modal__wrapp--policy[data-policy="policy"]').css('display', 'flex');
      document.body.style.overflow = 'hidden';
      policy = true;
    }
  })

  $('.modal__close--policy').click(function(){
    if(policy == true){
      $('.modal-policy').removeClass('mp-open');
      $('.modal__wrapp--policy[data-policy="policy"]').css('display', 'none');
      document.body.style.overflow = 'auto';
      policy = false;
    }
  })

})

var items = document.querySelectorAll('input[type="tel"]');

items.forEach(function(el) {
  var dispatchMask = new IMask(el, {
    mask: [
      {
        mask: '+7 (000) 000-00-00',
        startsWith: '7',
        lazy: false,
        country: 'Russia'
      },
      {
        mask: '8 (000) 000-00-00',
        startsWith: '8',
        lazy: false,
        country: 'Russia'
      },
      {
        country: 'Azerbaijan',
        mask: '+994 (00) 000-00-00',
        lazy: false,
        startsWith: '994'
      },
      {
        country: 'Armenia',
        mask: '+374 (00) 000-000',
        lazy: false,
        startsWith: '374'
      },
      {
        country: 'Belarus',
        mask: '+375 (00) 000-00-00',
        lazy: false,
        startsWith: '375'
      },
      {
        country: 'Kazakhstan',
        mask: '+7 (000) 000-00-00',
        lazy: false,
        startsWith: '7'
      },
      {
        country: 'Kyrgyz',
        mask: '+996 (000) 000-000',
        lazy: false,
        startsWith: '996'
      },
      {
        country: 'Moldova',
        mask: '+373 (000) 000-00',
        lazy: false,
        startsWith: '373'
      },
      {
        country: 'Tajikistan',
        mask: '+992 (00) 000-0000',
        lazy: false,
        startsWith: '992'
      },
      {
        country: 'Uzbekistan',
        mask: '+998 (00) 000-0000',
        lazy: false,
        startsWith: '998'
      },
      {
        country: 'Ukraine',
        mask: '+380 (00) 000-0000',
        lazy: false,
        startsWith: '380'
      },
      {
        mask: '+(000) 000-00-00',
        startsWith: '',
        country: 'unknown'
      }
    ],
    dispatch: function (appended, dynamicMasked) {
      var number = (dynamicMasked.value + appended).replace(/\D/g,'');

      return dynamicMasked.compiledMasks.find(function (m) {
        return number.indexOf(m.startsWith) === 0;
      });
    }
  }
)
});

document.addEventListener( 'wpcf7mailsent', function( event ) {

  var inputs = event.detail.inputs;

  if ( '115' == event.detail.contactFormId ) { //оставить заявку и получить кп
    ym(90018441,'reachGoal','zayavka');
  } else if ( '113' == event.detail.contactFormId ){ //обсудить проблему
    ym(90018441,'reachGoal','problem');
  } else if ( '187' == event.detail.contactFormId ){ //аудит
    ym(90018441,'reachGoal','audit');
  } else if ( '228' == event.detail.contactFormId ){ //контакты
    ym(90018441,'reachGoal','zakaz_zvonok');
  } else if ( '119' == event.detail.contactFormId ){
    if(document.querySelector('input.service__input').value == "Сайты Start" || 
    document.querySelector('input.service__input').value == "Сайты PRO" ||
    document.querySelector('input.service__input').value == "Редизайн сайта"){
      ym(90018441,'reachGoal','zyyavka_site');
    } else if(document.querySelector('input.service__input').value == "SMM"){
      ym(90018441,'reachGoal','zayvka_smm');
    } else if(document.querySelector('input.service__input').value == "Брендинг и фирменный стиль"){
      ym(90018441,'reachGoal','zayavka_brend');
    } else if(document.querySelector('input.service__input').value == "CRM"){
      ym(90018441,'reachGoal','zayvka_crm');
    }
  }
}, false );

$(document).ready(function ()
{
    if (/iPhone/.test(navigator.userAgent) && !window.MSStream)
    {
        $(document).on("focus", "input, textarea, select", function()
        {
            $('meta[name=viewport]').remove();
            $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0">');
        });

        $(document).on("blur", "input, textarea, select", function()
        {
            $('meta[name=viewport]').remove();
            $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1">');
        });
    }
});